const typography = {
  fontFamily: "'Pretendard'",
}

export default typography
